import React, { useState } from 'react';

import Dashboardnavbar from '../../layout/Dashboardnavbar';
// import { SiteDesignationTable, SiteSubcompanyTable, SiteEmployeeDetails, ConsultantAccountDetails, SiteDepartment } from './WorkforceTable';
import usePermission from '../../config/permissions';
// import usePermission from '../../config/permissions';
import OfficeRent from './OfficeRent';
import OfficeBillingDetails from './OfficeBillingdetails';
import { Building2, Receipt, ReceiptIndianRupeeIcon } from 'lucide-react';
const OfficeManagement = () => {

    const siteRole = sessionStorage.getItem("sitemanagement_role")

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Office Rent';
            case 2:
                return 'Office Billing Details';
            default:
                return 'Office Rent';
        }
    };

    const tabs = [
        { id: 1, label: 'Office Rent', icon: Building2 },
        { id: 2, label: 'Office Billing Details', icon: ReceiptIndianRupeeIcon },
    ];

    const renderActiveComponent = () => {
        switch (toggleState) {
            case 1: return <OfficeRent />;
            case 2: return <OfficeBillingDetails />;
            default: return null;
        }
    };

    return (
        <>

            <div className="project-details-modern">
                <div className="project-content-modern">
                    <div className="modern-tabs-container">
                        <div className="tabs-scroll" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <div style={{ display: 'flex' }}>
                                {tabs.map((tab) => {
                                    const Icon = tab.icon;
                                    return (
                                        <button
                                            key={tab.id}
                                            className={`modern-tab-btn ${toggleState === tab.id ? 'active' : ''}`}
                                            onClick={() => setToggleState(tab.id)}
                                        >
                                            <Icon size={16} />
                                            <span>{tab.label}</span>
                                            {toggleState === tab.id && <div className="active-indicator" />}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="tab-content-modern">
                        {renderActiveComponent()}
                    </div>
                </div>
            </div>
        </>
    );
};





export default OfficeManagement;
